import { Header } from '@circlefin/components'
import { paymentMethodsSection } from '@services/sections/lib/billing'
import { BackButton } from '@shared/components/layout'
import { useCardPaymentMethodByIdQuery } from '@shared/graphql'
import useTranslation from 'next-translate/useTranslation'

export interface CardDetailsHeaderProps {
  /**
   * Merchant card ID for card details.
   */
  cardId: string
}

export const CardDetailsHeader: React.FC<CardDetailsHeaderProps> = ({
  cardId,
}) => {
  const { t } = useTranslation('settings')
  const { data, loading } = useCardPaymentMethodByIdQuery({
    variables: {
      id: cardId,
    },
  })

  return (
    <>
      <BackButton section={paymentMethodsSection} />
      <Header loading={loading} variant="secondary">
        <Header.Head
          title={t('billing.cardPayment.title', {
            network: data?.cardPaymentMethodById?.network,
            last4: data?.cardPaymentMethodById?.last4,
          })}
        />
      </Header>
    </>
  )
}
